import { render, staticRenderFns } from "./CouponLink.vue?vue&type=template&id=245dc5df&"
import script from "./CouponLink.vue?vue&type=script&lang=js&"
export * from "./CouponLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports